import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { GitBranch } from "lucide-react";

// Iter-204c — CEO-only block: toggle email alert when a non-CEO actor (typically a
// MANAGER) flips the type of a mission (REGIE ↔ FORFAIT).

export default function MissionTypeChangeAlertBlock() {
  const [enabled, setEnabled] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const s = await api.get("/settings");
        setEnabled(s.data.mission_type_change_email_alert_enabled !== false);
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Impossible de charger le paramètre");
      } finally { setLoaded(true); }
    })();
  }, []);

  const saveToggle = async (next) => {
    setSaving(true);
    try {
      await api.put("/settings", { mission_type_change_email_alert_enabled: next });
      setEnabled(next);
      toast.success(next ? "Alertes activées" : "Alertes désactivées");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Échec de la sauvegarde");
    } finally { setSaving(false); }
  };

  if (!loaded) return null;

  return (
    <div className="mb-8 border border-amber-200 bg-amber-50/30 rounded-lg p-5" data-testid="mission-type-change-alert-block">
      <div className="flex items-start gap-3">
        <GitBranch className="text-amber-700 mt-1" size={20} />
        <div className="flex-1">
          <h2 className="font-heading font-bold text-base">Alerte changement de type de mission</h2>
          <p className="text-xs text-zinc-600 mt-1 max-w-2xl">
            Reçoit un email immédiat quand un <strong>manager</strong> (ou tout acteur non-CEO) bascule
            le type d'une mission entre <strong>Régie</strong> et <strong>Forfait</strong>. Les changements
            effectués par un CEO ne déclenchent pas d'alerte (vous savez ce que vous faites).
            L'alerte capture l'acteur, la mission, le type avant/après et la cascade Weekly CRA.
          </p>
        </div>
        <Switch
          checked={enabled}
          onCheckedChange={saveToggle}
          disabled={saving}
          data-testid="mission-type-change-alert-toggle"
        />
      </div>
    </div>
  );
}
